import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../../../environments/environment';
@Injectable({
	providedIn: 'root'
})
export class IrsipDoctoralInformationServiceService {

	phdFieldOfStudyChanged$ = new Subject<string>(); // or whatever type
	IrsipCountrySelectChange$ = new Subject<string>(); // or whatever type

	triggerPhdFieldOfStudyChange(value: string) {
		this.phdFieldOfStudyChanged$.next(value);
	}

	triggerIrsipCountrySelectChange(value: string) {
		this.IrsipCountrySelectChange$.next(value);
	}

	constructor(public http: HttpClient) { }

	public saveApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveApplication', payload)
	}
}
